module.exports = __webpack_public_path__ + "static/media/accountant.651bbb87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/sliderPuzzle/accountant.png
// module id = 520
// module chunks = 0